export enum DeliveryType {
    DELIVERY = 'delivery',
    PICKUP = 'pickup',
}
